import { render, staticRenderFns } from "./contractDialog.vue?vue&type=template&id=24b2a41c"
import script from "./contractDialog.vue?vue&type=script&lang=js"
export * from "./contractDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports